import { useState } from "react";
import axios from "axios";
import { Button } from "../../reuseableComp.tsx/Button";
import { InputDiv } from "../../reuseableComp.tsx/InputWithLogo";
import EmailIcon from "../../useIconpark/emailIcon";
import {
  MainWrapper,
  CenteredObject,
  CenteredContent,
  TextArea,
  TextPtag,
  ButtonArea,
  Error,
} from "./style";
import SecurityIcon from "../../useIconpark/security";
import BackLink from "../../reuseable/BackLink";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { ProgressBar } from "react-loader-spinner";
import { FiEye, FiEyeOff } from "react-icons/fi";

const SignupComp = () => {
  const [contine, setContinue] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleContinue = () => {
    setContinue(true);
  };

  const payload = {
    email: email,
    password: password,
  };

  const handleCreateAccount = async () => {
    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_BASE_ENDPOINT}/sign-up`, payload)
      .then((res: any) => {
        const token = String(res.data.result.token);
        sessionStorage.setItem("token", token);
        const chatId = String(res.data.result.chatId);
        sessionStorage.setItem("chatId", chatId);
        setLoading(false);
        navigate("/verify");
      })
      .catch((err) => {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
        if (err.response && err.response.status === 403) {
          setError(err.response.data.message);
          setTimeout(() => {
            setError("");
          }, 3000);
        } else {
          console.error("Error during account creation:", err.message);
        }
      });
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <>
      <MainWrapper>
        <BackLink path="/" />
        <CenteredObject>
          <CenteredContent>
            <TextArea>
              {contine ? (
                <>
                  <h2>Enter Your password</h2>
                </>
              ) : (
                <>
                  <h2>What’s your Email Address?</h2>
                </>
              )}
            </TextArea>
            <TextPtag>
              {contine ? (
                <>
                  <p>Please Enter your Your Secret Password</p>
                </>
              ) : (
                <>
                  <p>Please Enter your Email Address to get started.</p>
                </>
              )}
            </TextPtag>

            <InputDiv>
              <div>
                <EmailIcon size={45} trigger="loop" delay={2000} />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </InputDiv>

            {contine && (
              <>
                <InputDiv className={password ? "active" : ""}>
                  <div>
                    <SecurityIcon size={45} trigger="loop" delay={2000} />
                  </div>
                  <div>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <button type="button" onClick={togglePasswordVisibility}>
                      {showPassword ? (
                        <FiEyeOff color="#000" />
                      ) : (
                        <FiEye color="#000" />
                      )}
                    </button>
                  </div>
                </InputDiv>
              </>
            )}

            {error && (
              <>
                <Error>
                  <p>{error}</p>
                </Error>
              </>
            )}

            <ButtonArea>
              {contine ? (
                <>
                  <Button
                    onClick={handleCreateAccount}
                    disabled={!email || !password}
                  >
                    {loading ? (
                      <>
                        <ProgressBar
                          height="60"
                          width="60"
                          ariaLabel="progress-bar-loading"
                          wrapperStyle={{}}
                          wrapperClass="progress-bar-wrapper"
                          borderColor="#F4442E"
                          barColor="#ffffff"
                        />
                      </>
                    ) : (
                      <>Sign-up</>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button disabled={!email} onClick={handleContinue}>
                    Continue
                  </Button>
                </>
              )}
            </ButtonArea>
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};
export default SignupComp;
